<script setup>
import SkeletonPlaceholder from '~/components/Base/SkeletonPlaceholder.vue'

const props = defineProps({
    legalContent: {
        type: Object,
        default: () => ({}),
        validator: (rawValue) => {
            const validations = {
                headline: rawValue => rawValue?.headline === undefined || typeof rawValue?.headline === 'string',
                placeholder: rawValue => rawValue?.placeholder === undefined || typeof rawValue?.placeholder === 'boolean',
                content: rawValue => rawValue?.content === undefined || typeof rawValue?.content === 'string',
            }

            return Object.values(validations).every(validation => validation(rawValue))
        }
    }

})

const { $md } = useNuxtApp()
const contentHtml = computed(() => $md.render(props.legalContent?.content || ''))
</script>

<template>
    <section class="legal-text">
        <ContentMainHeadline :content-main-headline-config="{ title: `_${legalContent?.headline}_` }" />

        <template v-if="legalContent?.placeholder">
            <component :is="SkeletonPlaceholder" :skeleton-placeholder-config="{ type: 'multi-headline', tag: 'h2', length: 80 }" />
            <br>
            <component :is="SkeletonPlaceholder" :skeleton-placeholder-config="{ type: 'text', iterator: 3, length: 80 }" />
            <br>
            <component :is="SkeletonPlaceholder" :skeleton-placeholder-config="{ type: 'text', iterator: 2, length: 70 }" />
            <br>
        </template>

        <article v-else class="legal-text" v-html="contentHtml" />
    </section>
</template>

<style lang="scss">
.legal-text {
    @include rte-text($mw: $component-width);
}
</style>
